import React, { Component } from 'react';
import './scss/App.scss';
import $ from "jquery";

import iconWhite from "./img/connection-icon-wh.png";
import trigger from "./img/connection-icon.png";
import extremeCloud from './img/ExtremeCloud-Logo_RGB.png';
import extremeAnalytics from './img/ExtremeAnalytics-RGB.png';
import extremeGuest from './img/ExtremeGuest-RGB.png';
import extremeWireless from './img/wireless.svg';
import extremeLocation from './img/ExtremeLocation-RGB.png';
import extremeAD from './img/ExtremeWireless-AirDefense-Logo_RGB.png';
import extremeControl from './img/ExtremeControl-RGB.png';
import managementCtr from './img/applications.png';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      header: "The Connected Hospital",
      subHeader: "",
      buttonText: "Learn More",
      currentContent: "0",
      resourceCenter: "Solution Resource Center",

     CARDS: [

      {
      cardHeader: "ICU",
      cardContent: "Reliable, high-performance, high-density wired and wireless, secure networking is critical in the ICU. ExtremeControl insures only authorized devices connect to the network, including voice devices, medical devices, emergency equipment, video and handhelds. ExtremeAnalytics monitors network traffic and data flows in the ICU.",
      link: "",
      logo: [
        {source: extremeAnalytics, URL: "https://www.extremenetworks.com/product/extremeanalytics/", classes: "product-logo product-logo31"},
        ]
      },

      {
      cardHeader: "OR",
      cardContent: "The wireless and wired network keeps all medical devices, instruments, infusion pumps, video, and voice devices in the OR securely working together. Policy-based network management insures only the right devices and people can connect to the network and prioritizes the data flows to balance the needs of streaming video with of voice and critical medical instruments. Location services provide the ability to track all Wi-Fi devices and even people, devices, and guests.",
      link: "",
      logo: [
        {source: managementCtr, URL: "https://www.extremenetworks.com/product/extreme-management-center/", classes: "product-logo product-logo11"},
        {source: extremeLocation, URL: "https://www.extremenetworks.com/product/extremelocation/", classes: "product-logo product-logo41"},
        ]
      },

      {
      cardHeader: "ED",
      cardContent: "Location-based services pinpoint the position of all hospital staff members and devices throughout the ED. Wi-Fi access points and beacons can locate any device that transmits either Wi-Fi or Bluetooth signals, including phones, trauma carts, crash carts, and emergency equipment. Seconds matters and Extreme solutions remove the guesswork, to pinpoint people and devices and insure everything is in the right place before examining new patients.",
      link: "",
      logo: [
        {source: extremeLocation, URL: "https://www.extremenetworks.com/product/extremelocation/", classes: "product-logo product-logo41"},
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo42"}
        ]

      },

      {
      cardHeader: "Patient Room",
      cardContent: "Wallplate access points provide a convenient way to deliver wireless networking to patients and doctors. Defender for IoT insures safe and secure connection of infusion pumps to the network. For legacy networks and devices challenged with addressing today’s IoT security concerns the Defender for IoT adapter creates an encrypted tunnel between the medical device and the data center applications reducing the risks to patient care. ",
      link: "https://content.extremenetworks.com/extreme-networks-blog/fighting-digital-giants-the-importance-of-wi-fi-analytics-for-physical-retail-stores",
      logo: [
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo42"}
        ]
      },

      {
      cardHeader: "IoHT",
      cardContent: "Clinical grade wallplate access points provide in-room connectivity and location services to wireless medical devices. Defender for IoT adapters safely create encrypted tunnels between legacy medical device and the data center applications, reducing the risks to patient care.",
      link: "",
      logo: [
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo42"}
        ]
      },
      {
      cardHeader: "Waiting Room",
      cardContent: "Wi-Fi access points provide reliable connection of personal devices to the Internet. Policy-based network management enable BYOD access, but prevents rogue attacks and insures security of clinical data.",
      link: "",
      logo: [
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo42"},
        {source: managementCtr, URL: "https://www.extremenetworks.com/product/extreme-management-center/", classes: "product-logo product-logo11"},

        ]
      },

      {
      cardHeader: "LDRP",
      cardContent: "Policy-based network management safely and securely separates the connectivity of staff devices from BYOD access of patients and guests. All authorized patient devices have smooth access to the network depending on the time and location. Network analytics verify that only authorized devices, users, and applications are using the network.",
      link: "",
      logo: [
        {source: managementCtr, URL: "https://www.extremenetworks.com/product/extreme-management-center/", classes: "product-logo product-logo11"},
        {source: extremeAnalytics, URL: "https://www.extremenetworks.com/product/extremeanalytics/", classes: "product-logo product-logo31"},
        ]
      },
      {
      cardHeader: "Dr. Office",
      cardContent: "Telemedicine is dependent on reliable and secure network connections. Network analytics verify the connection from end to end and prioritize the data flows. Remote networks can be easily cloud-managed, while the local network is managed on-premises.",
      link: "",
      logo: [
        {source: managementCtr, URL: "https://www.extremenetworks.com/product/extreme-management-center/", classes: "product-logo product-logo11"},
        {source: extremeAnalytics, URL: "https://www.extremenetworks.com/product/extremeanalytics/", classes: "product-logo product-logo31"},
        ]
      },
      {
      cardHeader: "Outpatient",
      cardContent: "Outpatient rooms have both wireless secure Internet infrastructure and wired high-speed broadband connections. The network is managed through a single pane of glass that controls secure access to clinical data, medical devices, and personal devices; as well as shows the location of all Wi-Fi devices.",
      link: "",
      logo: [
        {source: managementCtr, URL: "https://www.extremenetworks.com/product/extreme-management-center/", classes: "product-logo product-logo11"},
        {source: extremeLocation, URL: "https://www.extremenetworks.com/product/extremelocation/", classes: "product-logo product-logo62"}
        ]
      },
      {
      cardHeader: "iHome",
      cardContent: "The intelligent medical home runs on wireless networking. Network analytics track the data flow between endpoints to monitor the application data flowing across the Internet. If a problem arises, it is easy to determine whether it is a device fault, application issue or bandwidth shortage.  With cloud-managed networking, Wi-Fi access points are easily managed within the home, so that medical devices, wearables, and displays can be reliably connected and remotely monitored.",
      link: "",
      logo: [
        {source: extremeCloud, URL: "https://www.extremenetworks.com/product/extremecloud/", classes: "product-logo product-logo61"},
        {source: extremeAnalytics, URL: "https://www.extremenetworks.com/product/extremeanalytics/", classes: "product-logo product-logo31"},
        ]
      }

      ]


    };
  }

  addActive = (e) => {

    $(".details-wrap").addClass("active");
    let clicked = e.target;
    let i = $(clicked).data("card");
    console.log(i);
    this.setState({currentContent: i});



  }
  toggleClose = () => {
    $(".details-wrap").removeClass("active");
  }
  closeActive = (event) => {
    if(!$(event.target).closest('.details-wrap').length) {
      if($('.details-wrap').is(":visible")) {
        $('.details-wrap').removeClass("active");
      }
    }
  }



  render() {

    let cc = this.state.currentContent;
    let images = this.state.CARDS[cc].logo;

    let imageTags = images.map(function(item,i) {
      return <a href={item.URL} target="_blank" className="product-link" key={i}><img src={item.source} className={item.classes}/></a>
    });

    return (
      <div className="container App">


        <div className="row main" id="mainContent">
          <img src={trigger} alt="trigger" className="trigger-purple trigger-1" onClick={this.addActive} data-card="0" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-2" onClick={this.addActive} data-card="1" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-3" onClick={this.addActive} data-card="2" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-4" onClick={this.addActive} data-card="3" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-5" onClick={this.addActive} data-card="4" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-6" onClick={this.addActive} data-card="5" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-7" onClick={this.addActive} data-card="6" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-8" onClick={this.addActive} data-card="7" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-9" onClick={this.addActive} data-card="8" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-10" onClick={this.addActive} data-card="9" />

          <div className="col">
            <div className="row details-wrap">
              <div className="col details">
                <div className="row details-header">
                  <div className="col-3">
                    <img src={iconWhite} className="icon" alt="icon-white" />
                  </div>
                  <div className="col-9">
                    <h2>{this.state.CARDS[cc].cardHeader}</h2>
                    <i className="fa fa-times-circle close-icon" aria-hidden="true" onClick={this.toggleClose}></i>
                  </div>
                </div>
                <div className="row card-details">
                  <div className="col">

                    <p>{this.state.CARDS[cc].cardContent}</p>
                    {/*<a href={this.state.CARDS[cc].link} target="_blank">*/}
                      {/*<button className="learn-more">*/}
                        {/*{this.state.buttonText}*/}
                      {/*</button>*/}
                    {/*</a>*/}
                    {/*<h3 className="resource-center">{this.state.resourceCenter}</h3>*/}
                    <div className="logos">
                    <div className="product-logos">
                    {imageTags}
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js